/* @ngInject */

export default ($compile) => {
  const getTemplate = (fieldModel, isTicketSettled) => {
    const model = fieldModel;
    let template = '';
    switch (model.type.name) {
      case 'text_short':
        template += '<div layout-gt-sm="row" layout="column" flex>';
        template += '<md-input-container flex ng-class="{ \'disabled\': isTicketSettled }">';
        template +=
          '<label><span ng-bind="createModel.name"></span> <span ng-if="createModel.description" ng-bind="\'(\' + createModel.description + \')\'"></span></label>';
        template +=
          '<input ng-change="toggleChanges()" ng-model="createModel.value" ng-disabled="isTicketSettled" />';
        template += '</md-input-container>';
        template += '</div';
        break;
      case 'text_large':
        template += '<div layout-gt-sm="row" layout="column" flex>';
        template += '<md-input-container flex ng-class="{ \'disabled\': isTicketSettled }">';
        template +=
          '<label><span ng-bind="createModel.name"></span> <span ng-if="createModel.description" ng-bind="\'(\' + createModel.description + \')\'"></span></label>';
        template +=
          '<textarea ng-change="toggleChanges()" ng-model="createModel.value" ng-disabled="isTicketSettled" columns="1"></textarea>';
        template += '</md-input-container>';
        template += '</div>';
        break;
      case 'options_multiple':
        // eslint-disable-next-line valid-typeof
        if (typeof model.value !== 'array' && !model.value.length) {
          model.value = [];
        }
        template += '<div layout="column" flex class="mt1">';
        template += '<div layout="column" flex>';
        template += '<divider-header flex class="ml1 mr1">';
        template += '<strong>';
        template +=
          '<span ng-bind="createModel.name"></span> <span ng-if="createModel.description" ng-bind="\'(\' + createModel.description + \')\'"></span>';
        template += '</strong>';
        template += '</divider-header>';
        template += '</div>';
        template += '<div layout-gt-sm="row" layout="column" layout-wrap class="pa1">';
        for (let i = 0; i < model.fieldOptions().length; i += 1) {
          template +=
            '<st-form-field-container class="blank small pa0 mt1 mr0 mb1 ml0" flex-gt-sm="20" flex>';
          template += `<md-checkbox ng-change="toggleChanges()" ng-model="createModel.value[${i}]" ng-disabled="isTicketSettled" class="md-primary" aria-label="${
            model.fieldOptions()[i]
          }">${model.fieldOptions()[i]}</md-checkbox>`;
          template += '</st-form-field-container>';
        }
        template += '</div>';
        template += '</div>';
        break;
      case 'options_single':
        template += '<div layout="column" flex class="mt1">';
        template += '<div layout="column" flex>';
        template += '<divider-header flex class="ml1 mr1">';
        template += '<strong>';
        template +=
          '<span ng-bind="createModel.name"></span> <span ng-if="createModel.description" ng-bind="\'(\' + createModel.description + \')\'"></span></label>';
        template += '</strong>';
        template += '</divider-header>';
        template += '</div>';
        template += '<div layout="column">';
        template +=
          '<md-radio-group ng-model="createModel.value" ng-change="toggleChanges()" ng-disabled="isTicketSettled" layout-gt-sm="row" layout="column" layout-wrap class="md-primary pa1">';
        for (let i = 0; i < model.fieldOptions().length; i += 1) {
          template += `<md-radio-button value="${
            model.fieldOptions()[i]
          }" flex-gt-sm="20" flex class="pa0 mt1 mr0 mb1 ml0">${
            model.fieldOptions()[i]
          }</md-radio-button>`;
        }
        template += '</md-radio-group>';
        template += '</div>';
        template += '</div>';
        break;
      case 'number':
        template +=
          '<div layout-gt-sm="row" layout="column" flex ng-class="{ \'disabled\': isTicketSettled }">';
        template += '<md-input-container flex>';
        template +=
          '<label><span ng-bind="createModel.name"></span> <span ng-if="createModel.description" ng-bind="\'(\' + createModel.description + \')\'"></span></label>';
        template +=
          '<input ng-change="toggleChanges()" ng-model="createModel.value" ng-disabled="isTicketSettled" type="number" />';
        template += '</md-input-container>';
        template += '</div>';
        break;
      case 'money':
        template +=
          '<div layout-gt-sm="row" layout="column" flex ng-class="{ \'disabled\': isTicketSettled }">';
        template += '<md-input-container flex>';
        template +=
          '<label><span ng-bind="createModel.name"></span> <span ng-if="createModel.description" ng-bind="\'(\' + createModel.description + \')\'"></span></label>';
        template +=
          '<input ng-change="toggleChanges()" ng-model="createModel.value" ng-disabled="isTicketSettled" type="number" />';
        template += '</md-input-container>';
        template += '</div>';
        break;
      case 'phone':
        template +=
          '<div layout-gt-sm="row" layout="column" flex ng-class="{ \'disabled\': isTicketSettled }">';
        template += '<md-input-container flex>';
        template +=
          '<label><span ng-bind="createModel.name"></span> <span ng-if="createModel.description" ng-bind="\'(\' + createModel.description + \')\'"></span></label>';
        template +=
          '<input ng-change="toggleChanges()" ng-model="createModel.value" ng-disabled="isTicketSettled" type="number" />';
        template += '</md-input-container>';
        template += '</div>';
        break;
      default:
        template += '';
        break;
    }
    return template;
  };

  return {
    restrict: 'E',
    scope: {
      createModel: '=',
      isTicketSettled: '=',
      toggleChanges: '&'
    },
    link(scope, element) {
      const template = $compile(getTemplate(scope.createModel, scope.isTicketSettled))(scope);
      element.replaceWith(template);
    }
  };
};
